export enum SubsectionTypeRelation {
  NO_PHYSICAL_LOCATION = 0,
  ONLY_IN_ONE_FLOOR = 1,
  IN_MANY_FLOORS = 999,
}
